exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".summary-row{margin-right:0;margin-left:0;overflow:hidden}.arrow-down{width:0;height:0;margin-left:-10px;border-left:12px solid transparent;border-right:12px solid transparent;border-top:12px solid #fbbc98}@media (min-width:992px){.arrow-down{margin-top:-1px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Plans/Plans.scss
 ** module id = 1210
 ** module chunks = 0
 **/